// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"6dbc6414","551":"cd3fe300","828":"4d87e979","842":"d524723b"}[chunkId] + ".chunk.js";
};